import { isBrowser } from "react-device-detect";
import BrowserView from "./BrowserView";
import MobileView from "./MobileView";

declare global {
    interface Window {
        TypeHangul: any;
    }
}

function App() {
    return (
        <>
            {isBrowser
                ? <BrowserView />
                : <MobileView />
            }
        </>
    );
}

export default App;
